exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.isreturn[data-v-425512ea]{color:#000;cursor: pointer;\n}\n[data-v-425512ea].el-icon-arrow-left{color: #000;\n}\n#Return_Bar[data-v-425512ea] {\n    padding-left: 21px;\n    display: flex;\n    padding-top: 10px;\n    padding-bottom: 15px;\n    width: 100%;\n}\n[data-v-425512ea].el-icon-arrow-left {\n    margin-top: 5px;\n}\n.radioOrCheckedBox[data-v-425512ea]{\n  height:30px;border:1px solid #ddd;width:455px;padding-left:15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-425512ea","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/train/fbtExperienceChoose.vue
// module id = 1132
// module chunks = 0